<template>
  <div class="row g-2" id="custom-row">
    <div class="col-md">
      <div id="vehicle-box" class="info-box">
        <div class="txt-container">
          <div class="highlight-txt" v-if="!isLoading">{{ infoData.total }}</div>
          <div class="highlight-txt" v-else></div>
          <div class="description-txt">Vehicles</div>
        </div>
        <div class="img-container">
          <img src="@/assets/images/info-icon-truck.png" alt="image of truck icon"/>
        </div>
      </div>
    </div>
    <div class="col-md">
      <div id="mile-box" class="info-box">
        <div class="txt-container">
          <div class="highlight-txt" v-if="!isLoading">{{ infoData.miles }}</div>
          <div class="highlight-txt" v-else></div>
          <div class="description-txt">Miles traveled</div>
        </div>
        <div class="img-container">
          <img src="@/assets/images/info-icon-miles.png" alt="image of speedometer icon"/>
        </div>
      </div>
    </div>
    <div class="col-md">
      <div id="hour-box" class="info-box">
        <div class="txt-container">
          <div class="highlight-txt" v-if="!isLoading">{{ infoData.hours }}</div>
          <div class="highlight-txt" v-else></div>
          <div class="description-txt">Hours logged</div>
        </div>
        <div class="img-container">
          <img src="@/assets/images/info-icon-hour.png" alt="image of clock icon"/>
        </div>
      </div>
    </div>
    <div class="col-md">
      <div id="mpg-box" class="info-box">
        <div class="txt-container">
          <div class="highlight-txt" v-if="!isLoading">{{ infoData.mpg }}</div>
          <div class="highlight-txt" v-else></div>
          <div class="description-txt">Average MPG</div>
        </div>
          <img src="@/assets/images/info-icon-gas.png" alt="image of fuel pump icon"/>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'InfoBoxes',
  setup() {
    const store = useStore();
    const isLoading = computed(() => store.getters.isDataLoaded);

    const infoData = computed(() => {
      const boxData = store.getters.getInfoBox;
      if (boxData.total) {
        return {
          total: boxData.total,
          miles: boxData.miles,
          hours: boxData.hours,
          mpg: boxData.mpg,
        };
      }
      return {
        total: '',
        miles: '',
        hours: '',
        mpg: '',
      };
    });

    return {
      infoData,
      isLoading,
    };
  },
};

</script>
